import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import {TagsSortMode} from '../../../lib/tagsSort';

import styles from './TagsSortToggle.module.scss';

interface ITagsSortToggleProps {
    mode: TagsSortMode,
    onChange: (_mode: TagsSortMode) => void,
}

const TagsSortToggle: React.FC<ITagsSortToggleProps> = ({mode, onChange}) => {
    const options: {value: TagsSortMode, label: string}[] = [
        {value: 'label', label: t`По алфавиту`},
        {value: 'new', label: t`Сначала новые`},
    ];

    return (
        <div className={styles.toggle}>
            {options.map(({value, label}) => (
                <button
                    key={value}
                    type="button"
                    className={cn(styles.option, value === mode && styles.active)}
                    onClick={() => onChange(value)}
                    aria-pressed={value === mode}
                >
                    {label}
                </button>
            ))}
        </div>
    );
};

export default TagsSortToggle;
